<div class="relative p-6 bg-white z-1 dark:bg-gray-900 sm:p-0">
  <div class="relative flex flex-col justify-center w-full h-screen lg:flex-row dark:bg-gray-900 sm:p-0">
    <div class="flex flex-col flex-1">
      <div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
        <div>
          @if (!token) {
            <!-- Solicitar reset por email -->
            <div class="mb-5 sm:mb-8">
              <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
                Restablecer contraseña
              </h1>
              <p class="text-sm text-gray-500 dark:text-gray-400">
                Ingresa tu correo electrónico y te enviaremos las instrucciones
              </p>
            </div>

            <form [formGroup]="emailForm" class="space-y-6">
              <div>
                <app-label>Email <span class="text-error-500">*</span></app-label>
                <app-input-field
                  id="email"
                  type="email"
                  placeholder="email@gmail.com"
                  name="email"
                  formControlName="email"
                  ngDefaultControl
                />
              </div>

              <app-button
                className="w-full"
                size="sm"
                (btnClick)="requestReset()"
                [disabled]="!emailForm.valid || isLoading"
              >
                Enviar instrucciones
              </app-button>
            </form>
          } @else {
            <!-- Establecer nueva contraseña -->
            <div class="mb-5 sm:mb-8">
              <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
                Nueva contraseña
              </h1>
              <p class="text-sm text-gray-500 dark:text-gray-400">
                Ingresa tu nueva contraseña
              </p>
            </div>

            <form [formGroup]="passwordForm" class="space-y-6">
              <div>
                <app-label>Nueva contraseña <span class="text-error-500">*</span></app-label>
                <div class="relative">
                  <app-input-field
                    id="password"
                    [type]="showPassword ? 'text' : 'password'"
                    placeholder="Ingresa tu nueva contraseña"
                    name="password"
                    formControlName="password"
                    ngDefaultControl
                  />
                  <span
                    (click)="togglePasswordVisibility()"
                    class="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                  >
                    @if (showPassword) {
                      <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="fill-gray-500 dark:fill-gray-400 size-5">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0002 13.8619C7.23361 13.8619 4.86803 12.1372 3.92328 9.70241C4.86804 7.26761 7.23361 5.54297 10.0002 5.54297C12.7667 5.54297 15.1323 7.26762 16.0771 9.70243C15.1323 12.1372 12.7667 13.8619 10.0002 13.8619ZM10.0002 4.04297C6.48191 4.04297 3.49489 6.30917 2.4155 9.4593C2.3615 9.61687 2.3615 9.78794 2.41549 9.94552C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C13.5184 15.3619 16.5055 13.0957 17.5849 9.94555C17.6389 9.78797 17.6389 9.6169 17.5849 9.45932C16.5055 6.30919 13.5184 4.04297 10.0002 4.04297ZM9.99151 7.84413C8.96527 7.84413 8.13333 8.67606 8.13333 9.70231C8.13333 10.7286 8.96527 11.5605 9.99151 11.5605H10.0064C11.0326 11.5605 11.8646 10.7286 11.8646 9.70231C11.8646 8.67606 11.0326 7.84413 10.0064 7.84413H9.99151Z"></path>
                      </svg>
                    } @else {
                      <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="fill-gray-500 dark:fill-gray-400 size-5">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.63803 3.57709C4.34513 3.2842 3.87026 3.2842 3.57737 3.57709C3.28447 3.86999 3.28447 4.34486 3.57737 4.63775L4.85323 5.91362C3.74609 6.84199 2.89363 8.06395 2.4155 9.45936C2.3615 9.61694 2.3615 9.78801 2.41549 9.94558C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C11.255 15.3619 12.4422 15.0737 13.4994 14.5598L15.3625 16.4229C15.6554 16.7158 16.1302 16.7158 16.4231 16.4229C16.716 16.13 16.716 15.6551 16.4231 15.3622L4.63803 3.57709ZM12.3608 13.4212L10.4475 11.5079C10.3061 11.5423 10.1584 11.5606 10.0064 11.5606H9.99151C8.96527 11.5606 8.13333 10.7286 8.13333 9.70237C8.13333 9.5461 8.15262 9.39434 8.18895 9.24933L5.91885 6.97923C5.03505 7.69015 4.34057 8.62704 3.92328 9.70247C4.86803 12.1373 7.23361 13.8619 10.0002 13.8619C10.8326 13.8619 11.6287 13.7058 12.3608 13.4212ZM16.0771 9.70249C15.7843 10.4569 15.3552 11.1432 14.8199 11.7311L15.8813 12.7925C16.6329 11.9813 17.2187 11.0143 17.5849 9.94561C17.6389 9.78803 17.6389 9.61696 17.5849 9.45938C16.5055 6.30925 13.5184 4.04303 10.0002 4.04303C9.13525 4.04303 8.30244 4.17999 7.52218 4.43338L8.75139 5.66259C9.1556 5.58413 9.57311 5.54303 10.0002 5.54303C12.7667 5.54303 15.1323 7.26768 16.0771 9.70249Z"></path>
                      </svg>
                    }
                  </span>
                </div>
              </div>

              <div>
                <app-label>Confirmar contraseña <span class="text-error-500">*</span></app-label>
                <div class="relative">
                  <app-input-field
                    id="password_confirmation"
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    placeholder="Confirma tu contraseña"
                    name="password_confirmation"
                    formControlName="password_confirmation"
                    ngDefaultControl
                  />
                  <span
                    (click)="toggleConfirmPasswordVisibility()"
                    class="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                  >
                    @if (showConfirmPassword) {
                      <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="fill-gray-500 dark:fill-gray-400 size-5">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0002 13.8619C7.23361 13.8619 4.86803 12.1372 3.92328 9.70241C4.86804 7.26761 7.23361 5.54297 10.0002 5.54297C12.7667 5.54297 15.1323 7.26762 16.0771 9.70243C15.1323 12.1372 12.7667 13.8619 10.0002 13.8619ZM10.0002 4.04297C6.48191 4.04297 3.49489 6.30917 2.4155 9.4593C2.3615 9.61687 2.3615 9.78794 2.41549 9.94552C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C13.5184 15.3619 16.5055 13.0957 17.5849 9.94555C17.6389 9.78797 17.6389 9.6169 17.5849 9.45932C16.5055 6.30919 13.5184 4.04297 10.0002 4.04297ZM9.99151 7.84413C8.96527 7.84413 8.13333 8.67606 8.13333 9.70231C8.13333 10.7286 8.96527 11.5605 9.99151 11.5605H10.0064C11.0326 11.5605 11.8646 10.7286 11.8646 9.70231C11.8646 8.67606 11.0326 7.84413 10.0064 7.84413H9.99151Z"></path>
                      </svg>
                    } @else {
                      <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="fill-gray-500 dark:fill-gray-400 size-5">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.63803 3.57709C4.34513 3.2842 3.87026 3.2842 3.57737 3.57709C3.28447 3.86999 3.28447 4.34486 3.57737 4.63775L4.85323 5.91362C3.74609 6.84199 2.89363 8.06395 2.4155 9.45936C2.3615 9.61694 2.3615 9.78801 2.41549 9.94558C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C11.255 15.3619 12.4422 15.0737 13.4994 14.5598L15.3625 16.4229C15.6554 16.7158 16.1302 16.7158 16.4231 16.4229C16.716 16.13 16.716 15.6551 16.4231 15.3622L4.63803 3.57709ZM12.3608 13.4212L10.4475 11.5079C10.3061 11.5423 10.1584 11.5606 10.0064 11.5606H9.99151C8.96527 11.5606 8.13333 10.7286 8.13333 9.70237C8.13333 9.5461 8.15262 9.39434 8.18895 9.24933L5.91885 6.97923C5.03505 7.69015 4.34057 8.62704 3.92328 9.70247C4.86803 12.1373 7.23361 13.8619 10.0002 13.8619C10.8326 13.8619 11.6287 13.7058 12.3608 13.4212ZM16.0771 9.70249C15.7843 10.4569 15.3552 11.1432 14.8199 11.7311L15.8813 12.7925C16.6329 11.9813 17.2187 11.0143 17.5849 9.94561C17.6389 9.78803 17.6389 9.61696 17.5849 9.45938C16.5055 6.30925 13.5184 4.04303 10.0002 4.04303C9.13525 4.04303 8.30244 4.17999 7.52218 4.43338L8.75139 5.66259C9.1556 5.58413 9.57311 5.54303 10.0002 5.54303C12.7667 5.54303 15.1323 7.26768 16.0771 9.70249Z"></path>
                      </svg>
                    }
                  </span>
                </div>
              </div>

              <app-button
                className="w-full"
                size="sm"
                (btnClick)="resetPassword()"
                [disabled]="!passwordForm.valid || isLoading"
              >
                Restablecer contraseña
              </app-button>
            </form>
          }

          <div class="mt-5">
            <p class="text-sm font-normal text-center text-gray-700 dark:text-gray-400">
              <a
                routerLink="/login"
                class="text-brand-500 hover:text-brand-600 dark:text-brand-400"
              >
                Volver al inicio de sesión
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="items-center hidden w-full h-full lg:w-1/2 bg-brand-950 dark:bg-white/5 lg:grid relative">
      <div class="flex items-center justify-center z-1">
        <div class="flex flex-col items-center">
          <img
            src="/assets/images/logos/Logo VT para fondos oscuros png.png"
            alt="Vitrotech Logo"
            class="w-80 h-auto"
          />
        </div>
      </div>
    </div>
  </div>
</div>
